import { render, staticRenderFns } from "./Sdg03.vue?vue&type=template&id=615a53a4&scoped=true&"
import script from "./Sdg03.vue?vue&type=script&lang=js&"
export * from "./Sdg03.vue?vue&type=script&lang=js&"
import style0 from "./Sdg03.vue?vue&type=style&index=0&id=615a53a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a53a4",
  null
  
)

export default component.exports